import { create } from 'zustand'


export interface CatalyzerItem {
  nyTS: Date;
  text: string;
  stringDate: string;
  url: string;
};

type CatalyzerState = {
  items: CatalyzerItem[];
  setItems: (items: CatalyzerItem[]) => void;
  hoveredItemIndex: number | null;
  setHoveredItemIndex: (index: number | null) => void;
};

export const useCatalyzerStore = create<CatalyzerState>((set, get) => ({
  items: [],
  setItems: (items) => set(() => {
    console.log("Catalyzer data received: ", items);
    return { items: items };
  }),
  hoveredItemIndex: null,
  setHoveredItemIndex: (index) => set({ hoveredItemIndex: index }),
}));
